<template>
  <div class="api-storage api-module">
    <p class = "description">Tu proyecto puede almacenar pequeños fragmentos de datos que se mantendran durante todo el periodo de muestra de proyectos. Aqui puedes verlos.</p>
    <!-- Here you can see watch your sketch has stored. Your project can store small data that will be persistent across days.</p> -->
    <code>{{storagePreview}}</code>

    <div class = "btns" :class = "{'disabled': !editorConfig.isSketchRunning }">
      <button class = "btn btn-bg-colored btn-round" v-on:click = "reload">Recargar</button>
      <button class = "btn btn-bg-colored btn-round" v-on:click = "clear">Borrar</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApiStorage',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    editorConfig () {
      return this.$store.state.editorConfig
    },
    storagePreview () {
      return this.$store.state.storagePreview
    }
  },
  methods: {
    reload: function () {
      this.$eventHub.$emit('rtdata', { from: 'onStorageRequest' })
    },
    clear: function () {
      this.$eventHub.$emit('rtdata', { from: 'onStorageClear' })
      this.reload()
    }
  },
  mounted () {
  }
}
</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.api-storage {
  display: flex;
  height: 100%;
  position: absolute;
}

code {
  color: @secondaryTextColor;
  background: @backgroundConsole;
  width: 100%;
  // padding: 12px;
  flex: 3;
}

.btns {
  width: 100%;
  display: flex;
  justify-content: center;
  flex: 1;
  min-height: 55px;
  max-height: 55px;
}

button {
  padding: 10px;
  margin: 12px 8px;
  width: 92px;
}

</style>



// WEBPACK FOOTER //
// src/components/ApiModules/ApiStorage.vue